import { types } from "mobx-state-tree";
import {
  ICallEventChatItem,
  IDateSeparatorChatItem,
  IEmptyChatItem,
  IContactEnquiryChatItem,
  IMeetingEventChatItem,
  IMeetingChatItem,
  IMeetingSchedulerChatItem,
  INoteChatItem,
  INotificationChatItem,
  IStatusChangeChatItem,
  IUserEventChatItem,
  IUserTextChatItem,
  IFakeUserTextChatItem,
  ICobrowsingEventChatItem,
  ICTAEventChatItem,
  IWidgetFormEventChatItem,
  ITagsChangeChatItem,
  ITopicsChangeChatItem,
  CallEventChatItem,
  DateSeparatorChatItem,
  EmptyChatItem,
  ContactEnquiryChatItem,
  MeetingEventChatItem,
  MeetingChatItem,
  MeetingSchedulerChatItem,
  NoteChatItem,
  NotificationChatItem,
  StatusChangeChatItem,
  UserEventChatItem,
  UserTextChatItem,
  FakeUserTextChatItem,
  CobrowsingEventChatItem,
  CTAEventChatItem,
  WidgetFormEventChatItem,
  TagsChangeChatItem,
  TopicsChangeChatItem,
  ChatItemGroup
} from "./items";
import { IRoomSummaryChatItem, RoomSummaryChatItem } from "./items/RoomSummaryChatItem";

export const ChatItem = types.union(
  CallEventChatItem,
  DateSeparatorChatItem,
  EmptyChatItem,
  ContactEnquiryChatItem,
  MeetingEventChatItem,
  MeetingChatItem,
  MeetingSchedulerChatItem,
  NoteChatItem,
  NotificationChatItem,
  StatusChangeChatItem,
  UserEventChatItem,
  UserTextChatItem,
  FakeUserTextChatItem,
  CobrowsingEventChatItem,
  CTAEventChatItem,
  WidgetFormEventChatItem,
  TagsChangeChatItem,
  TopicsChangeChatItem,
  RoomSummaryChatItem
);

export type IChatItem =
  | ICallEventChatItem
  | IDateSeparatorChatItem
  | IEmptyChatItem
  | IContactEnquiryChatItem
  | IMeetingEventChatItem
  | IMeetingChatItem
  | IMeetingSchedulerChatItem
  | INoteChatItem
  | INotificationChatItem
  | IStatusChangeChatItem
  | IUserEventChatItem
  | IUserTextChatItem
  | IFakeUserTextChatItem
  | ICobrowsingEventChatItem
  | ICTAEventChatItem
  | IWidgetFormEventChatItem
  | ITagsChangeChatItem
  | ITopicsChangeChatItem
  | IRoomSummaryChatItem
  | ChatItemGroup;
